<template>
	<md-card class="md-layout-item md-size-100">
		<md-card-header class="md-card-header-text md-card-header-accent">
			<div class="card-text">
				<h4 class="title">Mensagens</h4>
			</div>
		</md-card-header>

		<md-card-content>
			<div class="md-layout md-layout-item md-size-100">
				<h3 class="md-layout-item">{{ clientName }}</h3>
				<div class="md-layout md-layout-item md-size-100 chat-container">
					<md-list class="md-layout-item md-double-line message-container md-size-100" v-chat-scroll>
						<div v-for="(message, idx) in messages" :key="idx">
							<md-list-item class="message-box" :class="message.class">
								<div class="md-list-item-text" :class="message.class">
									<span>{{ message.user }}</span>
									<p class="message-content">{{ message.content }}</p>
									<span class="message-timestamp">{{ message.timestamp.toLocaleString("pt-BR") }}</span>
								</div>
							</md-list-item>
						</div>
						<md-list-item v-if="typing">
							<div class="md-list-item-text">
								<p class="typing">digitando</p>
							</div>
						</md-list-item>
					</md-list>
					<md-field class="message-input">
						<label>Enviar mensagem</label>
						<md-input v-model="newMessage" @focus="startTyping()" @keyup="startTyping()" @keyup.enter="sendMessage()"></md-input>
						<md-button class="md-icon-button md-accent" @click="sendMessage()"><md-icon>send</md-icon></md-button>
					</md-field>
				</div>
			</div>
		</md-card-content>
	</md-card>
</template>

<script>
	import Twilio from "twilio-chat";

	import Chat from "@/models/chat.model.vue";
	import EspressoAux from "./EspressoAux.vue";

	export default {
		name: "ChatCard",
		props: {
			channelSid: String,
			clientId: Number,
			clientName: String,
		},
		data() {
			return {
				client: undefined,
				token: "",
				channel: undefined,
				messages: undefined,

				newMessage: "",
				typing: false,
			}
		},
		methods: {
			async start() {
				await this.getToken();
				await this.getClient();

				this.channel = await this.client.getChannelBySid(this.channelSid);

				await this.getMessages();
				await this.createListener();
			},
			async getToken() {
				const token = await Chat.getToken();
				this.token = token;
			},
			async getClient() {
				const client = await Twilio.create(this.token);
				this.client = client;
			},
			async createListener() {
				this.channel.on("messageAdded", async (message) => {
					const isClient = Number(message.author) === this.clientId;

					this.messages.push({
						user: Number(message.author === this.clientId) ? this.clientName : "Especialista",
						content: message.body,
						timestamp: message.timestamp,
						class: isClient ? "right message-client" : "left message-specialist",
					});
				});

				this.channel.on("typingStarted", () => {
					this.typing = true;
				});

				this.channel.on("typingEnded", () => {
					this.typing = false;
				});
			},
			async startTyping() {
				this.channel.typing();
			},
			async sendMessage() {
				if (this.newMessage) this.channel.sendMessage(this.newMessage);
				this.newMessage = "";
			},
			async getMessages() {
				const messages = await this.channel.getMessages();

				this.messages = messages.items.map((message) => {
					const isClient = Number(message.author) === this.clientId;

					return {
						user: isClient ? this.clientName : "Especialista",
						content: message.body,
						timestamp: message.timestamp,
						class: isClient ? "right message-client" : "left message-specialist",
					};
				});
			},
		},
		watch: {
			channelSid(value) { // Reload chat every times that channelSid changes
				if (value) {
					EspressoAux.showLoadingModal(this.start(), "Carregando mensagens", "Aguarde");
				}
			},
		},
	}
</script>

<style lang="scss" scoped>
	.chat-container {
		border: #000 1px solid;
		padding: 25px;

		border-radius: 10px;
	}

	.message-container {
		height: 60vh;
		padding: 0;

		overflow-y: scroll;
	}

	.message-specialist {
		color: #085858 !important;
		font-weight: 500;
	}

	.message-client {
		color: #0C885F !important;
		font-weight: 500;
	}

	.message-box {
		padding: 10px !important;
		margin: 10px;
		border-radius: 10px;
		background-color: #F4F4F4;
		max-width: 500px;

		.message-content {
			white-space: pre-wrap;
			margin-top: 10px;
		}

		.message-timestamp {
			padding-top: 10px;
		}
	}

	.message-input {
		margin-top: 35px;
	}

	.left {
		float: left;
	}

	.right {
		float: right;
	}

	.typing:after {
		overflow: hidden;
		display: inline-block;
		vertical-align: bottom;
		-webkit-animation: ellipsis steps(4,end) 900ms infinite;
		animation: ellipsis steps(4,end) 900ms infinite;
		content: "\2026"; /* ascii code for the ellipsis character */
		width: 0px;
	}

	@keyframes ellipsis {
		to {
			width: 1.25em;
		}
	}
</style>
